<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container" [dir]="dir"
  [ngClass]="{'minisidebar': minisidebar, 'boxed': boxed, 'danger': danger, 'blue': blue, 'green': green, 'horizontal' : horizontal }">

  <view-as *ngIf="isAllowedToViewAs" class="view-as-component"></view-as>

  <div class="main-content-container">
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <mat-toolbar color="primary" class="topbar relative">
      <div class="w-100 fix-width-for-horizontal">
        <!-- ============================================================== -->
        <!-- Logo - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div class="navbar-header">
          <a class="navbar-brand" href="/">
            <!-- Logo icon -->
            <b fxHide="false" fxHide.gt-xs>
              <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
              <!-- Dark Logo icon -->
              <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo">
              <!-- Light Logo icon -->
              <img src="assets/images/logo-light-icon.svg" alt="homepage" class="light-logo">
            </b>
            <!--End Logo icon -->
            <!-- Logo text -->
            <span fxShow="false" fxShow.gt-xs>
              <!-- dark Logo text -->
              <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo">
              <!-- Light Logo text -->
              <img src="assets/images/logo-light-text.svg" alt="homepage" class="light-logo light-logo-text">
            </span>
          </a>
        </div>
         <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->

        <button mat-icon-button (click)="snav.toggle()" class="sidebar-toggle" value="sidebarclosed">
          <mat-icon>menu</mat-icon>
        </button>
        <!-- ============================================================== -->
        <!-- Search - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div fxLayout="row" fxLayoutAlign="center center" class="w-100 company-container">
          <ng-container *ngIf="!isMultiCompanyOpen">
            <button color="basic" *ngIf="isMultiCompany && !isDefaultCompany" mat-button matSuffix mat-icon-button aria-label="Back to my company"
              tabindex="-1" (click)="onClickDefaultCompany();">
              <mat-icon>undo</mat-icon>
            </button>
            <button color="basic" *ngIf="isMultiCompany && isDefaultCompany" mat-button matPrefix mat-icon-button aria-label="Change company"
              tabindex="-1" (click)="onClickChangeCompany();">
              <mat-icon>swap_horiz</mat-icon>
            </button>
            <span *ngIf="!isMultiCompanyOpen" class="company" [class.multi-company]="isMultiCompany" (click)="onClickChangeCompany();">
              {{ selectedCompany?.name }} <small *ngIf="selectedCompany?.parentCompanyId">{{ getParentCompany(selectedCompany.parentCompanyId) }}</small>
            </span>
          </ng-container>

          <input [class.hidden]="!isMultiCompanyOpen" type="text" placeholder="Search" aria-label="Number" matInput
            [matAutocomplete]="companyControl" [formControl]="companyAutocomplete" autocomplete="off" #companyInput
            #companyTrigger="matAutocompleteTrigger" class="text-center">
          <mat-autocomplete #companyControl="matAutocomplete" autoActiveFirstOption [displayWith]="displayCompany"
            (optionSelected)="onCompanyChange($event.option.value)" (closed)="forceCompanySelection()">
            <mat-option *ngFor="let company of filteredCompanies" [value]="company">
              <div [innerHtml]="company.displayName | encodeHtml | highlight: companyAutocomplete.value"></div>
          </mat-option>
          </mat-autocomplete>
        </div>
        <span fxFlex></span>
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        <div *ngIf="!horizontal else horizontalheader">
          <app-vertical-header [isViewAsOpen]="isViewAsOpen" [isAllowedToViewAs]="isAllowedToViewAs"
            (clickSignOut)="onClickSignOut()" (clickSignIn)="onClickSignIn()" (clickShowViewAs)="onClickShowViewAs()"
            (clickHideViewAs)="onClickHideViewAs()"></app-vertical-header>
        </div>

        <ng-template #horizontalheader>
          <app-horizontal-header (clickSignOut)="onClickSignOut()" (clickSignIn)="onClickSignIn()">
          </app-horizontal-header>
        </ng-template>

        <!-- ============================================================== -->
        <!-- Theme toggle -->
        <!-- ============================================================== -->
        <button (click)="darkClick()" mat-icon-button class="ml-xs overflow-visible" title="Toggle Dark Mode">
          <mat-icon>{{ useDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>
        <button (click)="toggleMinisidebar()" mat-icon-button class="ml-xs overflow-visible" title="Toggle Mini Sidebar">
          <mat-icon>{{ minisidebar ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
      </div>

    </mat-toolbar>
    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
      [ngClass]="{'minisidebar': minisidebar}">
      <!-- ============================================================== -->
      <!-- Sidebar - style you can find in sidebar.scss -->
      <!-- ============================================================== -->
      <mat-sidenav #snav id="snav" class="pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0"
        [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true"
        (close)="sidebarOpened = false">

        <perfect-scrollbar *ngIf="!horizontal; else horizontalsidebar" class="scbar" [config]="config">
          <app-vertical-sidebar class="app-sidebar" [showClass]='status' (notify)="snav.toggle()"
            (clickSignOut)="onClickSignOut()">
          </app-vertical-sidebar>
        </perfect-scrollbar>

        <ng-template #horizontalsidebar>
          <app-horizontal-sidebar></app-horizontal-sidebar>
        </ng-template>
      </mat-sidenav>

      <!-- ============================================================== -->
      <!-- Sidebar - style you can find in sidebar.scss -->
      <!-- ============================================================== -->

      <!-- ============================================================== -->
      <!-- Page container - style you can find in pages.scss -->
      <!-- ============================================================== -->
      <mat-sidenav-content class="page-wrapper" [ngClass]="status ? 'minitoggle' : ''">
        <app-banner></app-banner>
        <app-breadcrumb></app-breadcrumb>
        <div *ngIf="showLoadingBar | async">
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
        <div class="page-content">
          <router-outlet>
            <app-spinner></app-spinner>
          </router-outlet>
        </div>
      </mat-sidenav-content>
      <!-- ============================================================== -->
      <!-- Page container - style you can find in pages.scss -->
      <!-- ============================================================== -->
    </mat-sidenav-container>
    <!-- <version-notification></version-notification> -->
  </div>
</div>